<template>
    <div class="panel panel-default exchanges-box">
        <div class="panel-heading">
            Échanges hors contrat
        </div>
        <ul class="panel-body list-group">
            <exchange-row :ex="ex" v-for="ex of client.exchanges"></exchange-row>
        </ul>
    </div>
</template>

<style scoped>
    .panel-body {
        padding: 0;
    }
</style>

<script type="text/ecmascript-6">
    import ExchangeRow from './ExchangeRow';

    export default {
        components: {
            ExchangeRow
        },
        props: {
            client: {
                required: true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ExchangesBox.vue?52bcbbee